import { getLanguageFromLocale, getZoneFromSite } from '@seek/melways-sites';
import { createSelector } from 'reselect';

import { authenticationStatuses } from 'src/constants/taxonomy';
import { getBrandFromSite, getCountryFromSite } from 'src/siteConfig';
import {
  selectHasAnalyticsTimedOut,
  selectSeekAdvertiserId,
  selectAdCentreUserId,
  selectAuthenticationStatus,
  selectSite,
  selectLocale,
  selectUserEmail,
  selectFullName,
  selectUnpaidInvoices,
  selectPaymentInvoiceIds,
} from 'src/store/selectors';

const isLoggedIn: Record<string, boolean> = {
  [authenticationStatuses.AUTHENTICATED]: true,
  [authenticationStatuses.UNAUTHENTICATED]: false,
} as const;

export const selectReadyToSendAnalytics = createSelector(
  selectHasAnalyticsTimedOut,
  selectSeekAdvertiserId,
  selectAdCentreUserId,
  selectAuthenticationStatus,
  (hasAnalyticsTimedOut, seekAdvertiserId, adCentreUserId) =>
    Boolean(hasAnalyticsTimedOut || (seekAdvertiserId && adCentreUserId)),
);

export const selectAnalyticsGlobals = createSelector(
  selectSeekAdvertiserId,
  selectAdCentreUserId,
  selectAuthenticationStatus,
  selectSite,
  selectLocale,
  selectUserEmail,
  selectFullName,
  selectUnpaidInvoices,
  selectPaymentInvoiceIds,
  (
    seekAdvertiserId,
    userId,
    authenticationStatus,
    site,
    locale,
    email,
    fullName,
    unpaidInvoices,
    paymentInvoiceIds,
  ) => ({
    seekAdvertiserId,
    userId,
    isLoggedIn: isLoggedIn[authenticationStatus],
    siteCountry: getCountryFromSite(site),
    brand: getBrandFromSite(site),
    zone: getZoneFromSite(site),
    siteLanguage: getLanguageFromLocale(locale),
    hirerUserEmail: email,
    hirerUserFullName: fullName,
    payInvoiceCount: paymentInvoiceIds?.length ?? 'unknown',
    payableInvoiceCount: unpaidInvoices?.length ?? 'unknown',
  }),
);
